import * as React from "react";
import * as ReactDOM from "react-dom";
import { IOWidget, Options, option, mk_widget, Widget } from "../widget";

export type ButtonOptions = Options & {
  disabled?:boolean
}

export let button = function<a>(label:string, options?:ButtonOptions) : IOWidget<() => a,a> {
  return (input:() => a) =>
    mk_widget({
      run:(on_done:(output:a) => void) =>
        <button {...option("extraProperties", options)}
                id={option("id", options)}
                className={option("className", options)}
                key={options ? options.key : undefined}
                disabled={option("disabled", options)}
                style={option("style", options)}
                onClick={e => on_done(input())} >
          {label}
        </button>
    })
}


export let button_wrapper = function<a>(inner_widget:Widget<{}>, options?:ButtonOptions) : IOWidget<() => a,a> {
  return (input:() => a) =>
    mk_widget({
      run:(on_done:(output:a) => void) =>
        <button {...option("extraProperties", options)}
                id={option("id", options)}
                className={option("className", options)}
                key={options ? options.key : undefined}
                disabled={option("disabled", options)}
                style={option("style", options)}
                onClick={e => on_done(input())} >
          {inner_widget.run(_ => ({}))}
        </button>
    })
}
